module.exports = __webpack_public_path__ + "img/tick-square.b56f35d2.svg";